<script setup lang="ts">
import { computed } from 'vue'
import type { LiveOpsEventWithTemplate } from '@/composables/game/live-ops-events'
import { useNow } from '@/composables/game/time'
import { HomeButton } from '@/components/home'

const props = withDefaults(defineProps<{
  event: LiveOpsEventWithTemplate
  containerClass?: string
}>(), {
  containerClass: '',
})

const { now } = useNow()

const countdownForEventEnd = computed(() => {
  return Math.max(0, props.event.endTimestamp - now.value)
})

const containerStyle = computed(() => {
  return { background: `linear-gradient(90deg, ${props.event.template.mainColor} 0%, #1C1C1E 100%)` }
})
</script>

<template>
  <HomeButton
    variant="bottom"
    no-border
    :countdown="{ value: countdownForEventEnd, dangerThreshold: 3600 * 12 }"
    :container-style="containerStyle"
    :label="event.template.name"
  >
    <img
      class="size-[38px] object-cover"
      :src="event.template.mainIconUrl"
    >
  </HomeButton>
</template>

